import { render, staticRenderFns } from "./PatientCurrentDataSummary.vue?vue&type=template&id=80bf39c6"
import script from "./PatientCurrentDataSummary.vue?vue&type=script&lang=js"
export * from "./PatientCurrentDataSummary.vue?vue&type=script&lang=js"
import style0 from "./PatientCurrentDataSummary.vue?vue&type=style&index=0&id=80bf39c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports